import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaguriProiecteComponent } from './taguri-proiecte.component';
import { AddTaguriProiecteComponent } from './add-taguri-proiecte/add-taguri-proiecte.component';
import { EditTaguriProiecteComponent } from './edit-taguri-proiecte/edit-taguri-proiecte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';



@NgModule({
    declarations: [
        TaguriProiecteComponent,
        AddTaguriProiecteComponent,
        EditTaguriProiecteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [TaguriProiecteComponent]
})
export class TaguriProiecteModule { }
